import React from 'react';
import { CloudUpload } from '@mui/icons-material';
import { DanelEmptyStateProps } from './types';
import { useDanelEmptyState } from './useDanelEmptyState';
import styles from './DanelEmptyState.module.scss';

const DanelEmptyState: React.FC<DanelEmptyStateProps> = props => {
  const { isDisabled, handleUploadExcel, handleUploadKasefet } =
    useDanelEmptyState(props);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Let's Start</h1>
      <p className={styles.description}>
        Upload encrypted vault files from your bank or Excel transaction files
        to process and manage your financial data
      </p>
      <div className={styles.buttonContainer}>
        <button
          className={`${styles.uploadButton} ${styles.primary}`}
          onClick={handleUploadKasefet}
          disabled={isDisabled}
        >
          <CloudUpload className={styles.icon} />
          UPLOAD VAULT
        </button>
        <button
          className={`${styles.uploadButton} ${styles.outlined}`}
          onClick={handleUploadExcel}
          disabled={isDisabled}
        >
          <CloudUpload className={styles.icon} />
          UPLOAD EXCEL
        </button>
      </div>
    </div>
  );
};

export default DanelEmptyState;
